<header class="main_menu home_menu">
    <app-header></app-header>
</header>

<router-outlet></router-outlet>

<footer class="footer-area">
    <app-footer></app-footer>
</footer>
